/**
 * =========================================================================
 * Modification
 * =========================================================================
 * Date: 12/01/2023
 * ID  : MDF-NF-20230112
 * Desc: e-Mailing of issue to staff
 *      - Dev component SelectMultipleEmails, implement in SettingPermissionMa
 *      - Remove variable is declared but its value is never read
 * =========================================================================
 */
import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import {
  FormControl,
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  Button,
  IconButton,
  Toolbar,
  AppBar,
  Dialog,
  Tabs,
  Tab,
  Slide,
  Paper,
  Grid,
} from '@material-ui/core';
import MaterialTable, { MTableToolbar } from 'material-table';

import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import * as settingPermissionManageAction from '../../../actions/settingPermissionManage.action';
import { useDispatch, useSelector } from 'react-redux';

// import Formik and Dependency
import { Formik, Form, Field } from 'formik';
import { Select, TextField } from 'formik-material-ui';
import * as Yup from 'yup';
import SelectMultiPersonalDataCategory from '../../fragments/SelectMultiPersonalDataCategory';
import globalStyles from '../../../styles/globalStyles';
import SelectPermissionLevelAdmin from '../../fragments/SelectPermissionLevelAdmin';
import SelectNameOrEmail from '../../fragments/SelectNameOrEmail';
import SelectDepartment from '../../fragments/SelectDepartment';
import SelectMultipleEmails from '../../fragments/SelectMultipleEmails/SelectMultipleEmails';
import { muiTable } from '../../../constants/index';
import { Backdrops } from './../../fragments/Loading/react-loadingg';

const styles = (theme) => ({
  ...globalStyles(theme),
  root: {
    flexGrow: 1,
    //backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    position: 'relative',
    backgroundColor: theme.palette.primary.dark,
  },
  appBarTab: {
    backgroundColor: theme.palette.primary.light,
    color: '#222',
  },
  title: {
    //marginLeft: theme.spacing(2),
    flex: 1,
  },
  TabPanel: {
    padding: theme.spacing(1),
  },
  menuButton: {
    marginLeft: theme.spacing(1),
  },
  toolbar: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1, 0, 1, 0),
  },
  card: {
    minWidth: 400,
    padding: theme.spacing(0, 2, 3, 2),
  },
  cardContent: {
    minHeight: 400,
  },
  section: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1),
  },
  tableHeight: {
    body: { minHeight: '10px !important' },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const TabPanel = (props) => {
  const { children, value, index, classes, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`setting-permission-tabpanel-${index}`}
      aria-labelledby={`setting-permission-tab-${index}`}
      {...other}
      style={{ minHeight: 250, padding: 5 }}
    >
      {<Box component="div">{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `setting-permission-tab-${index}`,
    'aria-controls': `setting-permission-tabpanel-${index}`,
  };
}

const validationSchema = Yup.object().shape({
  category_id: Yup.string().required(
    'กรุณาระบุประเภทของข้อมูลส่วนบุคคลที่มีการละเมิด'
  ),
  departmentId: Yup.string().required('กรุณาระบุส่วนงาน'),
  permissionLevel_id: Yup.string().required('กรุณาระบุระดับการดำเนินการ'),
  // user_id: Yup.bool().required('กรุณาระบุผู้ใช้งาน').oneOf([true], "กรุณาระบุผู้ใช้งาน"),
  permissionGroupName: Yup.string().required('กรุณาระบุกลุ่มสิทธิ์ผู้ใช้งาน'),
});

// InitialVaue of form reporting breach
let initialValues = {
  permissionLevel_id: '',
  keycodes: '',
  departmentId: '',
  permissionGroupName: '',
  permissionGroupDescription: '',
  category_id: '',
  categoryValue: [],
  user_id: '',
  userValue: [],
  userData: [],
};
let initialValuesTabIndex = {
  permissionLevel_id: 0,
  keycodes: 0,
  departmentId: 0,
  permissionGroupName: 0,
  permissionGroupDescription: 0,
  category_id: 1,
  user_id: 2,
};

// Show from reporting breach
const FormSettingPermission = ({
  values,
  setFieldValue,
  touched,
  errors,
  classes,
  actionStatus,
  handleClose,
  isSubmitting,
}) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const SettingPermissionSaveReducer = useSelector(
    ({ SettingPermissionSaveReducer }) => SettingPermissionSaveReducer
  );

  const [categoryValue, setCategoryValue] = React.useState([]);

  const [userData, setUserData] = React.useState(values.userData);
  const [nameValue, setNameValue] = React.useState([]);

  //const [departmentId, setDepartmentId] = React.useState('');
  let labelData = 'ข้อมูลสิทธิ์';
  let labelCategory = 'ประเภท';
  let labelUserName = 'ผู้ใช้งาน';

  // MDF-NF-20230112
  let labelNotifyResieverEmail = 'อีเมลผู้รับการแจ้งเตือน';

  let labelSave = 'บันทึก';
  let labelCancel = 'ยกเลิก';
  let labelPermissionGroup = 'ชื่อกลุ่มสิทธิ์ผู้ใช้งาน';
  let columnName = [
    {
      title: 'รูปภาพ',
      field: 'image',
      render: (rowData) => (
        <>
          <img src={rowData.image} style={{ width: 40, borderRadius: '90%' }} />
        </>
      ),
    },
    { title: 'ชื่อ-นามสกุล', field: 'fullName' },
    { title: 'อีเมล', field: 'email' },
  ];

  useEffect(() => {
    let isFound = false;
    if (isSubmitting && Object.keys(errors).length > 0) {
      Object.keys(initialValuesTabIndex).forEach((key, index) => {
        if (errors[key] != undefined && isFound == false) {
          isFound = true;
          setValue(initialValuesTabIndex[key]);
        }
      });
      isFound = false;
    }
  }, [isSubmitting]);

  //Reference of material-table
  const tableRef = useRef();
  return (
    <div>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            className={classes.menuButton}
          >
            {actionStatus.action == 'add' ? <AddIcon /> : <EditTwoToneIcon />}
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {actionStatus.label}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <AppBar position="static" className={classes.appBarTab}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="setting permission tabs"
        >
          <Tab label={labelData} {...a11yProps(0)} />
          <Tab label={labelCategory} {...a11yProps(1)} />
          <Tab label={labelUserName} {...a11yProps(2)} />
          <Tab label={labelNotifyResieverEmail} {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <Form autoComplete="off">
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <CardActions style={{ justifyContent: 'flex-end' }}>
              <Button variant="contained" color="primary" type="submit">
                {labelSave}
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  handleClose(false);
                }}
              >
                {labelCancel}
              </Button>
            </CardActions>

            <Paper className={classes.paper} elevation={0}>
              <TabPanel value={value} index={0}>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    component={TextField}
                    name="permissionGroupName"
                    type="text"
                    label={labelPermissionGroup + ' *'}
                  />
                </FormControl>

                <SelectPermissionLevelAdmin
                  name="permissionLevel_id"
                  className={classes.formControl}
                  value={values.permissionLevel_id}
                  onChange={(e, context) => {
                    setFieldValue('permissionLevel_id', e.target.value);
                    //setFieldValue('permissionLevelName', context);
                  }}
                  touched={
                    touched.permissionLevel_id && touched.permissionLevel_id
                  }
                  errors={
                    errors.permissionLevel_id && errors.permissionLevel_id
                  }
                />
                <SelectDepartment
                  name="departmentId"
                  className={classes.formControl}
                  value={values.departmentId}
                  onChange={(value, context) => {
                    setFieldValue('departmentId', value);
                    //setFieldValue('departmentName', context);

                    //setDepartmentId(value);
                  }}
                  touched={touched.departmentId && touched.departmentId}
                  errors={errors.departmentId && errors.departmentId}
                />

                <FormControl
                  fullWidth
                  className={classes.formControl}
                  error={false}
                >
                  <Field
                    component={TextField}
                    name="permissionGroupDescription"
                    type="text"
                    label={'คำอธิบายเพิ่มเติม'}
                  />
                </FormControl>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <SelectMultiPersonalDataCategory
                  name="category_id"
                  className={classes.formControl}
                  value={values.categoryValue}
                  onChange={(e) => {
                    setFieldValue('category_id', e.length > 0 ? e[0].name : '');
                    setFieldValue('categoryValue', e);
                    //setCategoryValue(e);

                    //setFieldValue('categoryName', context);
                  }}
                  touched={touched.category_id && touched.category_id}
                  errors={errors.category_id && errors.category_id}
                />
              </TabPanel>

              <TabPanel value={value} index={2}>
                <SelectNameOrEmail
                  name="user_id"
                  className={classes.formControl}
                  value={values.userValue} //userValue
                  onChange={(v) => {
                    setFieldValue('user_id', v.length > 0);
                    setFieldValue('userValue', v);

                    //setUserValue(v);
                    let CheckAdded = false;
                    for (let i = 0; i < userData.length; i++) {
                      if (userData[i].user_id == v[0].user_id) {
                        CheckAdded = true;
                        break;
                      }
                    }

                    if (CheckAdded == false) {
                      setUserData([...userData, ...v]);
                      setFieldValue('userData', [...userData, ...v]);
                    }
                  }}
                  touched={touched.user_id && touched.user_id}
                  errors={errors.user_id && errors.user_id}
                />

                <Grid container>
                  <Grid item xs={12} xl={12}>
                    <MaterialTable
                      tableRef={tableRef}
                      title=""
                      columns={columnName}
                      options={{
                        headerStyle: {
                          textAlign: 'center',
                          fontWeight: 'bold',
                        },
                        cellStyle: {
                          textAlign: 'center',
                          padding: '5px',
                        },
                      }}
                      data={userData}
                      localization={{
                        ...muiTable.localization,
                        header: {
                          actions: 'ลบ',
                        },
                      }}
                      actions={[
                        {
                          icon: 'delete',
                          tooltip: (
                            <span
                              style={{ fontSize: '0.9rem', padding: '10px' }}
                            >
                              {'ลบผู้ใช้งาน'}
                            </span>
                          ),
                          onClick: (event, rowData) => {
                            let filtered = userData.filter(
                              (item) => item.user_id != rowData.user_id
                            );

                            setUserData(filtered);
                            setFieldValue('userData', filtered);
                            setFieldValue('user_id', filtered.length > 0);
                          },
                        },
                      ]}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <SelectMultipleEmails
                  name="noticedEmails"
                  defaultValues={values.noticedEmails}
                  onChange={(val) => setFieldValue('noticedEmails', val)}
                />
              </TabPanel>
            </Paper>
          </CardContent>
        </Card>
      </Form>
    </div>
  );
};
const FormSettingPermissions = React.memo(
  withStyles(styles)(FormSettingPermission)
);

const SettingPermissionManagePage = (props) => {
  const {
    open,
    setOpen,
    classes,
    actionStatus,
    keyValues,
    setFieldValue,
    touched,
    errors,
    isSubmitting,

    ...rest
  } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();
  const SettingPermissionSaveReducer = useSelector(
    ({ SettingPermissionSaveReducer }) => SettingPermissionSaveReducer
  );
  const SettingPermissionManageByIdReducer = useSelector(
    ({ SettingPermissionManageByIdReducer }) =>
      SettingPermissionManageByIdReducer
  );

  const loadSettingPermissionById = () => {
    dispatch(
      settingPermissionManageAction.loadSettingPermissionById(keyValues)
    ).then(() => {});
  };

  useEffect(() => {
    if (actionStatus.action == 'edit') {
      loadSettingPermissionById();
    }
  }, []);
  let permissionGroupData;
  if (actionStatus.action == 'add') {
    initialValues = {
      permissionLevel_id: '',
      keycodes: '',
      departmentId: '',
      permissionGroupName: '',
      permissionGroupDescription: '',
      category_id: '',
      categoryValue: [],
      user_id: '',
      userValue: [],
      userData: [],
      noticedEmails: [],
    };
  } else {
    permissionGroupData = SettingPermissionManageByIdReducer.result.content;
    if (permissionGroupData.group != undefined) {
      //set default tab1
      initialValues.permissionLevel_id =
        permissionGroupData.group.permissionLevel_id;
      initialValues.permissionGroupName = permissionGroupData.group.name;
      initialValues.departmentId = permissionGroupData.group.keycodes;
      initialValues.permissionGroupDescription =
        permissionGroupData.group.description == null
          ? ''
          : permissionGroupData.group.description;
      //set default tab2
      initialValues.categoryValue = permissionGroupData.categorys;
      initialValues.category_id =
        permissionGroupData.categorys.length > 0
          ? permissionGroupData.categorys[0].name
          : '';
      initialValues.userData = permissionGroupData.users;

      //set default tab3
      initialValues.noticedEmails = permissionGroupData.noticedEmails || [];
    }
  }
  return (
    <div>
      <Backdrops
        open={
          SettingPermissionManageByIdReducer.isFetching == null
            ? false
            : SettingPermissionManageByIdReducer.isFetching
        }
      />
      {actionStatus.action == 'add' ||
      (actionStatus.action == 'edit' &&
        SettingPermissionManageByIdReducer.isFetching == false) ? (
        <Dialog
          open={open}
          fullScreen={fullScreen}
          fullWidth={true}
          maxWidth={'xl'}
          onClose={handleClose}
          TransitionComponent={Transition}
          disableBackdropClick={true}
          // className={classes.dialogPaper}
        >
          <Formik
            validationSchema={validationSchema}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              let data = {
                group: {
                  permissionLevel_id: values.permissionLevel_id,
                  keycodes: values.departmentId,
                  name: values.permissionGroupName,
                  description:
                    values.permissionGroupDescription == ''
                      ? null
                      : values.permissionGroupDescription,
                },
                categorys: values.categoryValue,
                users: values.userData,
                noticedEmails: values.noticedEmails,
              };

              if (actionStatus.action == 'edit') {
                data.group['id'] = keyValues;
              }

              console.log('Save values:', { values });

              dispatch(
                actionStatus.action == 'add'
                  ? settingPermissionManageAction.saveSettingPermission(data)
                  : settingPermissionManageAction.editSettingPermission(data)
              ).then(() => {
                setSubmitting(false);
                setOpen(false);
                rest.reloadTable();
              });
            }}
          >
            {({
              values,
              setFieldValue,
              touched,
              errors,
              isSubmitting,
              resetForm,
            }) => (
              <FormSettingPermissions
                actionStatus={actionStatus.label}
                handleClose={handleClose}
                errors={errors}
                touched={touched}
                values={values}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                {...props}
              />
            )}
          </Formik>
          {/* <div>
            <Formik><SelectMultipleEmails /></Formik>
          </div> */}
        </Dialog>
      ) : null}
    </div>
  );
};
export default React.memo(withStyles(styles)(SettingPermissionManagePage));
